import { parseISO } from 'date-fns'

import { EMPTY_STRING } from '../../../../../../../constants/common'
import { getListingDateValue } from '../../../../../RentalPortal.utils'
import { MATCH_ISO_DATE_PATTERN } from '../../../../../RentalPortalMatch'
import { getIsMatchEditorDateKind } from '../../ApplicantFitCheckBlockRowEditor'

export function getMatchEditValue(criterion) {
  const { applicant_value: value } = criterion

  if (!getIsMatchEditorDateKind(criterion)) {
    return value == null ? EMPTY_STRING : String(value)
  }

  return value && MATCH_ISO_DATE_PATTERN.test(value) ? parseISO(value) : null
}

export function getMatchPayloadValue({ criterion, value }) {
  return getIsMatchEditorDateKind(criterion)
    ? getListingDateValue(value)
    : Number(value)
}
